<template>
  <div class="cart-page">
    <!-- 购物车列表 -->
    <div class="cart-list">
      <div v-for="(item, index) in cartItems" :key="item.goodsId" class="cart-item">
        <checkbox v-model="item.checked" @click="itemCheck"></checkbox>
        <div class="item-img">
          <van-image :src="item.goodsIcon" fit="cover" />
        </div>
        <div class="item-info">
          <drugTag :product="item" />
          <p class="item-price">¥{{ item.salePrice }}</p>
          <pointPrice v-if="false" :product="item" />
        </div>
        <div class="item-quantity">
          <stepper
            v-model="item.number"
            theme="round"
            button-size="22"
            disable-input
            min="0"
            :max="item.stock"
            @change="refreshInfo(item, index)"
          />
          <!-- <van-icon name="minus" size="16px" @click="decreaseQuantity(item)" />
          <span class="quantity">{{ item.number }}</span>
          <van-icon name="plus" size="16px" @click="increaseQuantity(item)" /> -->
        </div>
      </div>
    </div>

    <van-empty
      v-if="!cartItems.length"
      class="custom-image"
      image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
      description="购物车暂无商品"
      image-size="80"
    />

    <!-- 底部悬浮结算栏 -->
    <div class="settle-bar" v-if="cartItems.length">
      <checkbox v-model="allCheck" style="font-size: 10px" @click="allCheckChange">
        <span>全选</span>
        <span class="total-price"
          >合计：
          <span class="price">¥{{ calcInfo.payAmount }}</span>
        </span>
      </checkbox>

      <van-button type="primary" size="small" @click="handleSettle" round :disabled="canSettle">
        去结算{{ !canSettle ? `(${checkedGoodsCount})` : '' }}
      </van-button>
    </div>

    <!-- 分开结算弹窗 -->
    <van-popup v-model="showSeparatePopup" round position="center">
      <div class="separate-popup">
        <div class="popup-title">请分开结算以下商品</div>
        <div class="popup-content">
          <div class="radio-item" @click="selectType('mallPrescription')">
            <van-radio name="prescription" v-model="selectedType">处方药</van-radio>
            <span class="count">{{ prescriptionCount }}件</span>
          </div>
          <div class="radio-item" @click="selectType('other')">
            <van-radio name="other" v-model="selectedType">其他商品</van-radio>
            <span class="count">{{ otherCount }}件</span>
          </div>
        </div>
        <div class="popup-footer">
          <van-button plain type="primary" @click="showSeparatePopup = false">返回购物车</van-button>
          <van-button type="primary" @click="handleSeparateSettle">{{
            selectedType === 'mallPrescription' ? '去开方' : '去结算'
          }}</van-button>
        </div>
      </div>
    </van-popup>

    <tabbar :curIndex="2" />
  </div>
</template>

<script>
import tabbar from '../components/tabbar';
import { Image as VanImage, Icon, Button, Empty, Stepper, Checkbox, Popup, Radio } from 'vant';
import services from '@/service';
import { wxAuthTo, notRequest } from '@/lib/utils';
import pointPrice from '@/components/pointPrice';
import drugTag from '@/components/drugTag';

export default {
  components: {
    drugTag,
    tabbar,
    Stepper,
    [VanImage.name]: VanImage,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Empty.name]: Empty,
    Checkbox,
    pointPrice,
    [Popup.name]: Popup,
    [Radio.name]: Radio
  },
  data() {
    return {
      cartItems: [], // 购物车列表
      calcInfo: {},
      allCheck: false,
      showSeparatePopup: false,
      selectedType: 'mallOrderConfirm'
    };
  },
  computed: {
    pageInit() {
      return !notRequest();
    },
    // 计算总价
    totalPrice() {
      return this.cartItems.reduce((total, item) => total + item.price * item.quantity, 0).toFixed(2);
    },
    canSettle() {
      return this.cartItems.filter(i => i.checked).length === 0;
    },
    // 计算处方药数量
    prescriptionCount() {
      return this.cartItems
        .filter(i => i.checked && i.medicineType === 'RX')
        .reduce((total, item) => total + item.number, 0);
    },
    // 计算其他商品数量
    otherCount() {
      return this.cartItems
        .filter(i => i.checked && i.medicineType !== 'RX')
        .reduce((total, item) => total + item.number, 0);
    },
    // 计算勾选商品总数
    checkedGoodsCount() {
      return this.cartItems.filter(i => i.checked).reduce((total, item) => total + item.number, 0);
    }
  },
  async created() {
    if (!this.pageInit) return;

    await this.loadCartData();
  },
  methods: {
    itemCheck() {
      this.allCheck = this.cartItems.filter(i => i.checked).length === this.cartItems.length ? true : false;
      this.setCartCheck();
      this.calculatePrice();
    },
    allCheckChange() {
      this.cartItems.forEach(i => {
        i.checked = this.allCheck;
      });
      this.setCartCheck();
      this.calculatePrice();
    },
    async refreshInfo(item, index) {
      if (item.number === 0) {
        await this.deleteMall(item.mallCartId);
        this.cartItems.splice(index, 1);
      } else {
        await this.updataMall(item);
      }
      this.calculatePrice();
    },
    async deleteMall(id) {
      await services.mall.deleteMall(id);
    },
    async updataMall(product) {
      const params = {
        goodsId: product.goodsId,
        number: product.number,
        goodsName: product.name,
        salePrice: product.salePrice,
        goodsIcon: product.goodsIcon
      };
      await services.mall.addMallCart(params);
    },
    async calculatePrice() {
      if (!this.cartItems.filter(i => i.checked).length) {
        return;
      }
      this.$store.dispatch('addLoading');

      const params = {
        // addressCityName: this.addressInfo.city,
        // addressDetail: this.addressInfo.address,
        // addressMobile: this.addressInfo.phone || this.clinicInfo.phone,
        // addressName: this.addressInfo.addressee,
        // addressProvinceName: this.addressInfo.province,
        // addressRegionName: this.addressInfo.district,
        clinicId: this.$store.getters.curClinicId,
        clinicName: this.$store.getters.curClinicName,
        consumptionPoints: 0,
        membershipPoints: 0,
        mallOrderDetailAoList: this.cartItems
          .filter(i => i.checked)
          .map(i => {
            return {
              goodsId: i.goodsId,
              number: i.number
            };
          })
      };
      const res = await services.mall.calculatePrice(params);
      this.calcInfo = res.data;
      // this.cartItems = res.data.mallOrderDetailAoList;
      this.$store.dispatch('subLoading');
    },
    // 加载购物车数据
    async loadCartData() {
      const checkArr = this.getCartCheck();
      const data = await services.mall.mallCart();
      this.cartItems = data.rows.map(i => {
        return {
          ...i,
          checked: checkArr.includes(i.goodsId)
        };
      });
      // this.calculatePrice();
      this.itemCheck();
    },
    // 减少数量
    decreaseQuantity(item) {
      if (item.number > 1) {
        item.number--;
      } else {
        this.cartItems = this.cartItems.filter(i => i.id !== item.id);
      }
    },
    // 增加数量
    increaseQuantity(item) {
      item.number++;
    },
    // 处理结算
    handleSettle() {
      this.goToSettle(this.cartItems.filter(i => i.checked));
      // const checkedItems = this.cartItems.filter(i => i.checked);
      // const hasPrescription = checkedItems.some(i => i.medicineType === 'RX');
      // const hasOther = checkedItems.some(i => i.medicineType !== 'RX');

      // if (hasPrescription && hasOther) {
      //   this.showSeparatePopup = true;
      // } else {
      //   this.goToSettle(checkedItems);
      // }
    },
    // 选择商品类型
    selectType(type) {
      this.selectedType = type;
    },
    // 处理分开结算
    handleSeparateSettle() {
      const items = this.cartItems.filter(
        i => i.checked && (this.selectedType === 'mallPrescription' ? i.medicineType === 'RX' : i.medicineType !== 'RX')
      );
      console.log('items:', items);
      this.goToSettle(items);
      this.showSeparatePopup = false;
    },
    // 跳转结算
    goToSettle(items) {
      const arr = items.map(i => ({
        goodsId: i.goodsId,
        number: i.number,
        mallCartId: i.mallCartId
      }));

      wxAuthTo({
        routerName: this.selectedType === 'mallPrescription' ? 'mallPrescription' : 'mallOrderConfirm',
        query: {
          products: arr
        }
      });
    },
    getCartCheck() {
      const arr = JSON.parse(localStorage.getItem('cartCheck') || '[]');
      return arr;
    },
    setCartCheck() {
      const arr = this.cartItems.filter(i => i.checked).map(i => i.goodsId);
      localStorage.setItem('cartCheck', JSON.stringify(arr));
    },
    goPrescribe() {
      const arr = [
        {
          goodsId: this.info.drugsId,
          number: 1
        }
      ];

      wxAuthTo({
        routerName: 'mallPrescription',
        query: {
          products: arr
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.cart-page {
  padding-bottom: 150px; // 留出底部悬浮栏的位置

  .separate-popup {
    width: 280px;
    padding: 20px;

    .popup-title {
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      margin-bottom: 20px;
    }

    .popup-content {
      .radio-item {
        margin: 15px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;

        .count {
          color: $gray2;
          font-size: 14px;
        }
      }
    }

    .popup-footer {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      gap: 12px;
    }
  }

  .cart-list {
    // padding: 16px;

    .cart-item {
      display: flex;
      align-items: center;
      background: #fff;
      padding: 12px;
      border-bottom: 1px solid $bordercolor;
      // border-radius: 8px;
      // margin-bottom: 12px;
      // box-shadow: $box-shadow1;

      .item-img {
        width: 80px;
        height: 80px;
        margin: 0 12px;
        border-radius: $radius;
        overflow: hidden;

        .van-image {
          width: 100%;
          height: 100%;
        }
      }

      .item-info {
        flex: 1;

        .item-name {
          font-size: 14px;
          color: $gray1;
          margin-bottom: 8px;
          @include hiddenText();
        }

        .item-price {
          font-size: 14px;
          color: $red1;
          font-weight: 500;
        }
      }

      .item-quantity {
        display: flex;
        align-items: center;

        .quantity {
          margin: 0 12px;
          font-size: 14px;
          color: $gray1;
        }

        .van-icon {
          cursor: pointer;
        }
      }
    }
  }

  .settle-bar {
    margin: 0 20px;
    border-radius: $radius;
    position: fixed;
    bottom: calc(80px + env(safe-area-inset-bottom));
    left: 0;
    right: 0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: $tb $lr;
    box-shadow: $box-shadow1;

    .total-price {
      font-size: $size6;
      color: $gray1;
      font-weight: 500;
      margin-left: 10px;

      .price {
        color: $red1;
        font-size: $size1;
        font-weight: 600;
      }
    }

    .van-button {
      width: 100px;
      background: linear-gradient(to right, #ff6034, #ee0a24);
      border: none;
    }
  }

  .separate-popup {
    width: 280px;
    padding: 20px;

    .popup-title {
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      margin-bottom: 20px;
    }

    .popup-content {
      .radio-item {
        margin: 15px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;

        .count {
          color: $gray2;
          font-size: 14px;
        }
      }
    }

    .popup-footer {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      gap: 12px;

      .van-button {
        flex: 1;
        height: 34px;
        border-radius: 20px;
        font-size: 15px;

        &--primary {
          &.van-button--plain {
            background: #fff;
            border-color: #ff6034;
            color: transparent;
            background-clip: text;
            -webkit-background-clip: text;
            background-image: linear-gradient(to right, #ff6034, #ee0a24);
          }

          &:not(.van-button--plain) {
            background: linear-gradient(to right, #ff6034, #ee0a24);
            border: none;
          }
        }
      }
    }
  }
}
</style>
